export default __webpack_public_path__ + "static/media/Kubri.518498d4.jpg";